import axios from 'axios'
import {config} from '../../config'

import getQuestionsMock from '../../mocks/getQuestionsMock.json'
import finishQuizMock from '../../mocks/finishQuizMock.json'
import getLeaderBoardMock from '../../mocks/getLeaderBoardMock.json'
import getResultMock from '../../mocks/getResultMock.json'
import startQuizMock from '../../mocks/startQuizMock.json'

export default class QuizServices {
 
  getQuestions(token, data){
    let url = config.baseUrl+'/quiz/question';
    return this.doPOST(url, token, data);
   // let url = './mocks/getQuestionsMock.json';
   // let url = 'http://localhost:7000/mocks/getQuestionsMock.json';
   // return this.doGET(url, token, data);
  }

  postStartQuiz(token, data){
    let url = config.baseUrl+'/quiz/start';
    return this.doPOST(url, token, data);
   // let url = './mocks/startQuizMock.json';
   //  let url = 'http://localhost:7000/mocks/startQuizMock.json';
    //return this.doGET(url, token, data);
  }

  postFinishQuiz(token, data){
    let url = config.baseUrl+'/quiz/finish';
    return this.doPOST(url, token, data);
   //let url = './mocks/finishQuizMock.json';
   // let url = 'http://localhost:7000/mocks/finishQuizMock.json';
   //return this.doGET(url, token, data);
  }

  getQuizResult(token, data){
    let url = config.baseUrl+'/quiz/result';
    return this.doPOST(url, token, data);
   // let url = './mocks/getResultMock.json';
    // let url = 'http://localhost:7000/mocks/getResultMock.json';
   // return this.doGET(url, token, data); 
  }

  getLeaderBoard(token, data){
    let url = config.baseUrl+'/quiz/leaderboard';
    return this.doPOST(url, token, data);
  }

  doPOST(url, token, data) {
     return axios.post(url, data, {
       headers:{
        'Content-Type':'application/json',
        'Authorization':'Bearer ' + token}
      });
  }

  doGET(url, token, data) {
     return axios.get(url, data, {
       headers:{
        'Content-Type':'application/json'}
      });
  }
}




// WEBPACK FOOTER //
// ./src/quiz/services/QuizServices.js